import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { RootState } from "../interfaces";
import { AppDispatch } from "../redux/_store/configureStore";
import { fetchIsLogged } from "../redux";
import { useEffect, useRef, EffectCallback, DependencyList } from 'react';

export function useEffectAfterFirstRender(effect: EffectCallback, deps: DependencyList): void {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) isFirstRender.current = false;
    else return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useIsLoggedSelector = () => useAppSelector(fetchIsLogged)
